import { render, staticRenderFns } from "./ViewCard.vue?vue&type=template&id=44f94ea9&"
import script from "./ViewCard.vue?vue&type=script&lang=js&"
export * from "./ViewCard.vue?vue&type=script&lang=js&"
import style0 from "./ViewCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports